<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações da Separação</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()" [matTooltip]="tooltipVoltar"
            [attr.aria-label]="tooltipVoltar">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Defina como a equipe separa, confere, embala e imprime os pedidos.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="48%" marginTop="12"></app-loading-box>
        <app-loading-box height="22" width="52%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="200" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="45%" marginTop="16"></app-loading-box>
        <app-loading-box height="22" width="55%" marginTop="12"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="240" marginTop="0"></app-loading-box>
        <app-loading-box height="22" width="50%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container mt-4">
        <app-loading-box height="30" width="160" marginTop="0"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <app-page-scroll-spy [sections]="sections"></app-page-scroll-spy>

        @if (!isTrabalhaComSeparacao) {
          <div class="conteudo-secao mt-3">
            <app-alert-card type="warning">
              A empresa não trabalha com separação. Estas configurações só passam a valer quando "Trabalha com
              Separação" for ativado em Configurações Gerais de Vendas.
            </app-alert-card>
          </div>
        }

        <!-- ================= Exibição e conferência ================= -->
        <div class="section-container" id="exibicao-conferencia">
          <div class="section-title">
            <mat-icon>visibility</mat-icon>
            <span>Exibição e conferência</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirObservacaoInternaVenda">Imprimir
                  observações internas da venda na separação</mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isExibirImagemProduto">Exibir imagem do
                  produto na separação e na impressão</mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isExibirCodigoBarrasGtin">Exibir código de
                  barras GTIN na separação e na impressão</mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirCodigoBarrasVenda">Imprimir
                  código de barras da venda</mat-slide-toggle>
                <span class="info-text">Apenas para impressão da listagem.</span>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirEstoqueFisico">Imprimir estoque
                  físico do produto</mat-slide-toggle>
                <span class="info-text">Exibe o saldo físico do produto (sem descontar reservas) na coluna "Estoque" da
                  impressão, no formato "Fís.: quantidade". Não afeta a tela de trabalho.</span>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImprimirEstoqueDisponivel">Imprimir
                  estoque disponível do produto</mat-slide-toggle>
                <span class="info-text">Exibe o saldo disponível do produto (já descontando reservas) na coluna "Estoque"
                  da impressão, no formato "Disp.: quantidade". Não afeta a tela de trabalho.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= Regras da separação ================= -->
        <div class="section-container mt-4" id="regras-separacao">
          <div class="section-title">
            <mat-icon>rule</mat-icon>
            <span>Regras da separação</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isConfirmarNumeroVolumes">Confirmar número
                  de volumes ao término da embalagem</mat-slide-toggle>
                <span class="info-text">Apenas para embalagem individual ou por pedido.</span>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isOcultarAdicaoManualItem">Ocultar ação
                  para adicionar itens manualmente no processo de embalagem</mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isReceberMarcadoresOrigem">Receber
                  marcadores da venda ou da nota fiscal nas separações/embalagem</mat-slide-toggle>
                <span class="info-text">Apenas os marcadores da origem principal são enviados, priorizando o pedido de
                  venda.</span>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isImpedirSeparacaoSimultanea">Impedir que
                  mais de um usuário separe ou embale o mesmo pedido</mat-slide-toggle>
              </div>
            </div>
          </div>
        </div>

        <!-- ================= Autorização de nota fiscal ================= -->
        <div class="section-container mt-4" id="autorizacao-nota-fiscal">
          <div class="section-title">
            <mat-icon>receipt_long</mat-icon>
            <span>Autorização de nota fiscal</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isPermitirAutorizacaoNfeSeparacao">Permitir
                  a autorização da nota fiscal ao separar pedidos</mat-slide-toggle>
              </div>
              <div class="toggle-content">
                <mat-slide-toggle class="app-toggle-compact" formControlName="isPermitirAutorizacaoNfeEmbalagem">Permitir
                  a autorização da nota fiscal ao concluir embalagem</mat-slide-toggle>
              </div>

              @if (mostrarAvisoAutomacaoNfe) {
                <app-alert-card type="info">
                  A autorização depende da automação "Autorizar NFe na Sefaz", hoje desligada.
                </app-alert-card>
              }

              <!-- Oculto sem expedição, mas o valor continua no formulário e é gravado. -->
              @if (isTrabalhaComExpedicao) {
                <div class="toggle-content">
                  <mat-slide-toggle class="app-toggle-compact" formControlName="isPermitirExpedicaoInicioEmbalagem">Permitir
                    criar e concluir expedições ao iniciar embalagem de pedidos</mat-slide-toggle>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- ================= Impressão ================= -->
        <div class="section-container mt-4" id="impressao">
          <div class="section-title">
            <mat-icon>print</mat-icon>
            <span>Impressão</span>
          </div>

          <div class="row mt-3 conteudo-secao">
            <div class="col-12 col-md-8">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Imprimir automaticamente ao finalizar embalagem</mat-label>
                <mat-select formControlName="listTipoDocumentoImpressao" [multiple]="true" placeholder="Não imprimir">
                  <mat-select-trigger>{{ resumoImpressaoAutomatica }}</mat-select-trigger>
                  @for (doc of opcoesTipoDocumentoImpressao; track doc.idTipoDocumentoImpressao) {
                    <mat-option [value]="doc.idTipoDocumentoImpressao">{{ doc.descricao }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>

            @if (isDanfeSelecionada) {
              <div class="col-12">
                <div class="bloco-separado">
                  <label class="bloco-titulo">Layout para impressão automática da DANFE</label>
                  <mat-radio-group formControlName="idTipoLayoutDanfe" class="radio-grupo-linha">
                    @for (t of opcoesTipoLayoutDanfe; track t.idTipoLayoutDanfe) {
                      <mat-radio-button [value]="t.idTipoLayoutDanfe">{{ t.descricao }}</mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              </div>
            }

            <div class="col-12">
              <div class="bloco-separado">
                <label class="bloco-titulo">Separador entre pedidos na impressão térmica</label>
                <mat-radio-group formControlName="idTipoSeparadorImpressaoTermica" class="radio-grupo-linha">
                  @for (t of opcoesTipoSeparadorImpressaoTermica; track t.idTipoSeparadorImpressaoTermica) {
                    <mat-radio-button [value]="t.idTipoSeparadorImpressaoTermica">{{ t.descricao }}</mat-radio-button>
                  }
                </mat-radio-group>
                <p class="hint-text mt-2 mb-0">Sem efeito quando apenas um pedido é impresso.</p>
              </div>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading || !configCarregada"
  (cancelar)="voltar()" (salvar)="salvar()">
</app-footer-action>
